export default __webpack_public_path__ + "static/media/OJO DE BUEY.3cb71008.jpg";